import type {
    ComponentChildren,
    JSX,
} from "preact";
import {
    forwardRef,
} from "preact/compat";

export type CardDensity = "compact" | "default";

type CardProps = JSX.HTMLAttributes<HTMLDivElement> & {
    children: ComponentChildren;
    density?: CardDensity;
};

const densityStyles: Record<CardDensity, string> = {
    default: "p-4",
    compact: "p-3",
};

export const Card = forwardRef<HTMLDivElement, CardProps>(
    ({
        className = "",
        density = "default",
        children,
        ...props
    }, ref) => {
        return (
            <div
                ref={ref}
                className={`bg-bg-secondary rounded-lg border border-border ${
                    densityStyles[density]
                } ${className}`}
                {...props}
            >
                {children}
            </div>
        );
    },
);

type CardHeaderProps = JSX.HTMLAttributes<HTMLDivElement> & {
    children: ComponentChildren;
};

export const CardHeader = forwardRef<HTMLDivElement, CardHeaderProps>(
    ({
        className = "",
        children,
        ...props
    }, ref) => {
        return (
            <div
                ref={ref}
                className={`mb-4 ${className}`}
                {...props}
            >
                {children}
            </div>
        );
    },
);

type CardTitleProps = JSX.HTMLAttributes<HTMLHeadingElement> & {
    children: ComponentChildren;
};

export const CardTitle = forwardRef<HTMLHeadingElement, CardTitleProps>(
    ({
        className = "",
        children,
        ...props
    }, ref) => {
        return (
            <h3
                ref={ref}
                className={`text-lg font-medium text-text-primary ${className}`}
                {...props}
            >
                {children}
            </h3>
        );
    },
);

type CardContentProps = JSX.HTMLAttributes<HTMLDivElement> & {
    children: ComponentChildren;
};

export const CardContent = forwardRef<HTMLDivElement, CardContentProps>(
    ({
        className = "",
        children,
        ...props
    }, ref) => {
        return (
            <div
                ref={ref}
                className={`text-text-secondary ${className}`}
                {...props}
            >
                {children}
            </div>
        );
    },
);
